export default "__VITE_ASSET__n1AgkGQX__"